<template>
  <div>
    <div class="relative">
      <span
        v-if="selectedItem === null"
        class="relative z-10 inline-block w-full rounded-md shadow-sm"
      >
        <input
          v-model="search"
          v-debounce:300ms="input"
          :placeholder="placeholder"
          class="relative w-full rounded-md border border-gray-300 bg-white pl-3 pr-10 py-2 text-left focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          @focus="showDropdown = true"
        >
      </span>

      <span
        v-if="selectedItem !== null"
        class="relative z-10 inline-block w-full rounded-md shadow-sm"
      >
        <div
          class="relative flex justify-between items-center w-full rounded-md border border-gray-300 bg-white pl-3 pr-3 py-2 text-left focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
        >
          <div>
            {{ selectedItem.primaryText }}
          </div>
          <!--
          <div
            class="text-gray-400 hover:text-gray-600 cursor-pointer transition-all duration-500"
            @click="reset"
          >
            <i class="far fa-times" />
          </div> -->
        </div>
      </span>

      <div
        v-if="search !== '' && selectedItem === null && displayResults"
        class="absolute z-20 w-full mt-1 bg-white shadow-lg rounded-md border"
      >
        <ul
          id="searchList"
          tabindex="-1"
          role="listbox"
          aria-labelledby="listbox-label"
          aria-activedescendant="listbox-item-3"
          :class="dropdownHeight"
          class="py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
        >
          <li
            v-for="(item, index) in results"
            id="listbox-item-0"
            :key="index"
            role="option"
            class="text-gray-900 cursor-pointer select-none relative py-2 pl-3 pr-9 hover:bg-gray-100"
          >
            <div
              class="flex space-x-2"
              @click="select(item)"
            >
              <span class="font-normal truncate">
                <div>{{ item.primaryText }}</div>
                <div class="text-gray-500 truncate">
                  {{ item.secondaryText }}
                </div>
              </span>
            </div>
          </li>
          <div
            v-if="!endOfList && loading"
            class="w-full min-w-full pb-1 text-center"
          >
            <LoadingSpinner class="ml-auto mr-auto" />
          </div>
          <div
            v-if="results.length === 0 && !loading"
            class="p-2 text-center"
          >
            No results
          </div>
        </ul>
      </div>
    </div>

    <div
      v-if="search !== '' && selectedItem === null && displayResults"
      class="fixed top-0 left-0 min-w-full w-screen h-screen min-h-screen"
      @click="showDropdown = false;"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import vueDebounce from 'vue-debounce';
import Checkbox from '@/app/shared/components/form/checkbox/checkbox.vue';
import LoadingSpinner from '@/app/shared/components/base/loading/loadingSpinner.vue';

Vue.use(vueDebounce);

export default {

  components: {
    LoadingSpinner,
  },

  props: {
    dropdownHeight: {
      type: String,
      default: 'max-h-60',
    },
    placeholder: {
      type: String,
      default: '',
    },
    results: {
      type: Array,
      default: [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showNoResults: {
      type: Boolean,
      default: true,
    },
    totalCount: {
      type: Number,
      default: undefined,
    },
    selectItem: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      search: '',
      selectedItem: null,
      scrollListenerAdded: false,
      showDropdown: true,
    };
  },

  computed: {
    endOfList() {
      return this.results.length === (this.totalCount + 1);
    },

    displayResults() {
      return (this.showNoResults || this.results.length > 0) && this.showDropdown;
    },
  },

  watch: {
    selectItem() {
      if (this.selectItem !== null) {
        this.selectedItem = this.selectItem;
      }
    },

    results() {
      if (!this.scrollListenerAdded && this.search !== '' && this.selectedItem === null && this.displayResults) {
        this.addScrollListener();
      }
    },
  },

  methods: {
    hideDropdown() {
      this.showDropdown = false;
    },

    reset() {
      if (this.selectedItem !== null) {
        if (confirm(`Are you sure you want to remove ${this.selectedItem.primaryText} from the tee time?`)) {
          this.search = '';
          this.selectedItem = null;
          this.$emit('reset');
        }
      }
    },

    input() {
      this.$emit('input', this.search);
    },

    addScrollListener() {
      const menu = document.getElementById('searchList');
      if (menu !== null) {
        this.scrollListenerAdded = true;
        menu.addEventListener('scroll', (e) => {
          if (!this.loading && this.totalCount !== undefined && !this.endOfList) {
            if ((menu.scrollHeight - menu.scrollTop) - 5 < menu.clientHeight) {
              this.$emit('skip');
            }
          }
        });
      }
    },

    select(item) {
      this.$emit('select', item);
      this.selectedItem = item;
    },
  },

};
</script>
